import React, {useEffect, useState} from "react";
import {List, Avatar, Card, message, Button, Modal, Drawer, Upload} from 'antd';
import {getHostAddress,getFrontEndAddress,getFileAddress} from "../../Tool/UtileFun";
import cookie from "react-cookies";
import {FileViewerTool} from "../Util/fileViewer/FileViewerTool";
import {getBackEndData} from "../../Tool/AxiosConnection";
import {UploadOutlined} from "@ant-design/icons";
import {DeleteButton} from "./DeleteButton";

export function ResourcesList(){

    useEffect(
        ()=>{
            findAllKnowledgeList()
        },[]
    )
    const [resources,setResources] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fileInfo,setFileInfo] = useState({})
    const [load,setLoad] = useState(false)
    const role = "role"

    const findAllKnowledgeList=()=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findAllKnowledgeList",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log(data)
                setResources(data)
            })
            .catch(error => message.error("error"+error));
    }

    const saveOtherFileInfo=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/edit",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(value),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //刷新视频
                findAllKnowledgeList()
            })
            .catch(error => message.error("error"+error));
    }

    const data = [
        {
            title: 'Ant Design Title 1',
        },
        {
            title: 'Ant Design Title 2',
        },
        {
            title: 'Ant Design Title 3',
        },
        {
            title: 'Ant Design Title 4',
        },
    ];

    const icon = (type)=>{
        if (type === 'xlsx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/xlsx.jpg"
        }
        if (type === 'pptx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/ppt.jpg"
        }
        if (type === 'docx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/docx.jpg"
        }
        if (type === 'jpg'){
            return "http://"+getFileAddress()+"/experimentResources/icon/picture.jpg"
        }
        if (type === 'pdf'){
            return "http://"+getFileAddress()+"/experimentResources/icon/pdf.jpg"
        }
        return "http://"+getFileAddress()+"/experimentResources/icon/otherFile.jpg"
    }

    const download = url => {
        // const eleLink = document.createElement('a');
        // eleLink.style.display = 'none';
        // // eleLink.target = "_blank"
        // eleLink.href = "http://"+getFileAddress+"/experimentResources/knowledgeLibrary/%E6%96%AF%E5%A4%A7%E6%9E%97.jpg";
        // // eleLink.href = record;
        // document.body.appendChild(eleLink);
        // eleLink.click();
        // //document.body.removeChild(eleLink);
        //window.open(url,"_blank");
        window.location.href  = url
        console.log(url)
        console.log("click")
    };

    const [fileFormat,setFileFormat] = useState("")
    const [fileName,setFileName] = useState("")
    const otherFileUpload = {
        name: 'file',
        listType: 'video',
        action: "http://"+getHostAddress()+"/resourcesAddress/videoUpload",
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload(file) {
            console.log(file.name)
            if (file.size > 1048576*500){
                message.info("上传文件最大支持500MB")
                return false
            }
            let fileName = file.name
            let format = ""
            let realFormat = ""
            for (let i = fileName.length - 1; i >= 0; i--) {
                console.log(fileName[i])
                if (fileName[i] === "."){
                    break
                }
                if (fileName[i] !== "."){
                    format = format + fileName[i]
                }
            }

            for (let i = format.length - 1 ; i >= 0 ; i--) {
                if (format[i] !=="."){
                    realFormat = realFormat + format[i]
                }
            }
            //记录文件名称和格式
            setFileName(file.name)
            setFileFormat(realFormat)
            return true
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 文件上传成功`);
                //上传成功后写入文件路径到数据库，刷新文件列表
                saveOtherFile(info.file.response.newFileName)
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
        },
    };


    const saveOtherFile=(value)=>{

        let uploadFileInfo = {
            knowledgeLibrary:"true",
            type:fileFormat,
            resourcesName:fileName,
            content:fileName,
            relativeAddress:"/experimentResources/knowledgeLibrary/"+value
        }
        saveOtherFileInfo(uploadFileInfo)
    }

    const showModal = (fileData) => {
        cookie.save("filePath",fileData.filePath)
        cookie.save("fileType",fileData.fileType)
        //window.open(getFrontEndAddress()+"/user/fileView")
        setLoad(true)
        setFileInfo(fileData)
        setIsModalVisible(true);
    };

    const fileViewFun=()=>{
        console.log(fileInfo)
        if (load === true){
            return <FileViewerTool {...fileInfo}></FileViewerTool>
        }
    }

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setFileInfo("")
    };

    const uploadButton=()=>{
        if (cookie.load(role) === "teacher"){
            return <Upload {...otherFileUpload}><Button icon={<UploadOutlined />}>上传文件</Button></Upload>
        }
    }

    const deleteFile=(item)=>{
        console.log(item)
        if (cookie.load(role) === "teacher") {
            return <Button type="link" danger onClick={deleteFileOnClick}>删除</Button>
        }
    }

    const deleteFileOnClick=(item)=>{
        console.log(item)
    }



    return(
        <>
            <Drawer
                title=""
                width={720}
                onClose={handleCancel}
                visible={isModalVisible}
                bodyStyle={{ paddingBottom: 80 }}
                >
                {fileViewFun()}
            </Drawer>
            {/*<Modal*/}
            {/*    title="Basic Modal"*/}
            {/*    visible={isModalVisible}*/}
            {/*    onOk={handleOk}*/}
            {/*    onCancel={handleCancel}*/}
            {/*>*/}
            {/*    <FileViewerTool {...fileInfo}></FileViewerTool>*/}
            {/*</Modal>*/}
            <Card title={"知识库"}
                  extra={uploadButton()}
            >
                <List
                    itemLayout="horizontal"
                    dataSource={resources}
                    pagination={{
                        // onChange: page => {
                        //     console.log(page);
                        // },
                        // pageSize: 5,
                    }}
                    renderItem={item => (
                        <List.Item
                            actions={[<a  onClick={()=>showModal({filePath:item.resourcesAddress,fileType:item.type,relativeAddress:item.relativeAddress})} key="list-loadmore-edit" target={"_blank"} download="filename">预览</a>,
                                <DeleteButton {...item}
                                              Event={()=>{
                                                  console.log("刷新执行")
                                                  findAllKnowledgeList()
                                              }}
                                ></DeleteButton>]}
                        >
                            <List.Item.Meta
                                avatar={<Avatar src={icon(item.type)} />}
                                title={<a href={"http://"+getFrontEndAddress()+item.relativeAddress} download={item.resourcesName}>{item.resourcesName}</a>}
                                //description={item.content}
                            />
                        </List.Item>
                    )}
                />
            </Card>
        </>
    )
}
